module.exports = __webpack_public_path__ + "img/facebook.0782624b.svg";